import React from "react";
import {
  faTwitter,
  faFacebook,
  faInstagram,
  faDribbble,
} from "@fortawesome/free-brands-svg-icons";
import SocialLink from "./SocialLink";
import "./MainFooter.css";

import footerLogo from "./images/logo-footer.svg";

import "./Mainfoooter.css";
import { Link, useLocation } from "react-router-dom";

const MainFooter = () => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === "blog") {
      return location.pathname.includes("blog");
    }
    return location.pathname.substring(1) === path;
  };

  return (
    <div className="main-footer">
      <div className=" uigrid footer-top">
        <div className="footer-logo uigrid-2">
          <img src={footerLogo} alt="" />
        </div>
        <div className="footer-sm-links uigrid-2">
          <div className="sm-links-inner">
            <SocialLink
              icon={faFacebook}
              link="https://www.facebook.com/awadigital"
            />
            <SocialLink
              icon={faInstagram}
              link="https://www.instagram.com/awa.digital"
            />
            <SocialLink
              icon={faTwitter}
              link="https://twitter.com/awadigitalco"
            />
            <SocialLink
              icon={faDribbble}
              link="https://dribbble.com/awadigital"
            />
          </div>
        </div>
      </div>
      <div className="uigrid footer-bottom">
        <div className="uigrid-9 footer-links">
          <ul>
            <li>
              <Link
                to="/platform"
                className={
                  isActive("platform") ? "nav-active hoverable" : "hoverable"
                }
              >
                Platform
              </Link>
            </li>
            <li>
              <a
                href="https://awashop.ng"
                className="hoverable"
                target="_blank"
                rel="noreferrer"
              >
                AwaShop
              </a>
            </li>
            <li>
              <a
                href="https://sendchops.com"
                className="hoverable"
                target="_blank"
                rel="noreferrer"
              >
                Sendchops
              </a>
            </li>
            <li>
              <Link
                to="/services"
                className={
                  isActive("services") ? "nav-active hoverable" : "hoverable"
                }
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/dedicated-team"
                className={
                  isActive("dedicated-team")
                    ? "nav-active hoverable"
                    : "hoverable"
                }
              >
                Dedicated team
              </Link>
            </li>
            <li>
              <Link
                to="/aboutUs"
                className={
                  isActive("aboutUs") ? "nav-active hoverable" : "hoverable"
                }
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                className={
                  isActive("blog") ? "nav-active hoverable" : "hoverable"
                }
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                to="/contactUs"
                className={
                  isActive("contactUs") ? "nav-active hoverable" : "hoverable"
                }
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div className="uigrid-3 footer-copyright">
          <p>© 2026 Awa Digital Ltd</p>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
